
<template>
    <div class="register-box" :style="`height:100vh;`">
        <div class="content-box">
            <div class="left-box">
                <p class="name">智能建造</p>
                <p class="name-1">虚拟仿真数字平台</p>
                <img style="margin-top: 50px;height: 40px;" src="../../assets/image/login/text.png" alt="">
                <p style="margin-top: 15px;" class="describe">海量虚仿一流课程免费共享</p>
                <p class="describe">丰富多样的学习资源</p>
                <p class="describe">数据分析、掌握学情</p>
                <p class="describe">多维度、更广阔的学习空间</p>
            </div>
            <div class="right-box">
                <i class="el-icon-close close-flag" @click="changeOperation('')"></i>
                <div class="back-box" @click="changeOperation('login')">
                    <i class="iconfont icon-fanhui"></i>
                    <p>返回登录</p>
                </div>
                <div class="first-box">
                    <p class="zd-register">终端注册</p>
                    <img style="width: 25px;" src="../../assets/image/login/des.png" alt="">
                </div>
                <div class="input-box">
                    <img style="width: 15px;" src="../../assets/image/login/account.png" alt="">
                    <el-select v-model="phone" style="width: 100px;" placeholder="">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model="form.loginName" @keydown.enter.native="save" maxlength="11" placeholder="请输入手机号"></el-input>
                </div>
                <div class="input-box">
                    <img style="width: 15px;" src="../../assets/image/login/txyzm.png" alt="">
                    <el-input maxlength="4" v-model="form.code" @keydown.enter.native="save" placeholder="请输入图形验证码"></el-input>
                    <img class="img" @click="queryCodeImg" :src="imgUrl" alt="">
                </div>
                <div class="input-box">
                    <img style="width: 15px;" src="../../assets/image/login/password.png" alt="">
                    <el-input v-model="form.passwd" @keydown.enter.native="save" type="password" placeholder="请输入登录密码"></el-input>
                </div>
                <div class="btn-box" @click="save">完成</div>
            </div>
        </div>
    </div>
</template>

<script>
import { QueryImgCode,QueryCode } from '@/api/common/common';
import { Register } from '@/api/systemAuth';
import CryptoJS from 'crypto-js';
    export default {
        data(){
            return{
               form:{
                "code": "",
                "key": "",
                "loginName": "",
                "passwd": "",
                "phoneCode": "",
                "userName": ""
               },
               phone:'',
               /**图片验证码url */
               imgUrl:'',
               /**手机验证码获取倒计时 */
               countdown:0,
                options:[
                    {
                        label:'+86',
                        value:'86'
                    }
                ]
            }
        },
        methods:{
            /**获取图片验证码 */
            queryCodeImg(){
                var params={
                    "generatorType": '1',
                    "height": 44,
                    "type": '3',
                    "width": 110,
                    "appCode":process.env.VUE_APP_APP_CODE,
                    'bizType':1
                }
                QueryImgCode(params).then(res=>{
                    if(res.code==200){
                        this.imgUrl=res.data.img;
                        this.form.key=res.data.key;
                        this.form.code='';
                    }
                })
            },
            changeOperation(value){
                this.$store.commit('changeGoLogin',value);
            },
            // /**获取手机验证码 */
            // queryPhoneCode(){
            //     var params={
            //         "captcha": this.form.code,
            //         "key": this.form.key,
            //         "number": this.form.loginName,
            //         "type": 1
            //     }
            //     QueryCode(params).then(res=>{
            //         if(res.code==200){
            //             this.form.phoneCode=res.data;
            //             this.countdown=60;
            //             var timer=setInterval(()=>{
            //                 this.countdown--;
            //                 if(this.countdown==0){
            //                     clearInterval(timer);
            //                 }
            //             },1000)
            //         }
            //     }).catch(err=>{
			// 		this.queryCodeImg();
			// 	})
            // },
            /**返回官网 */
            backHome(){
                this.$router.push('/');
            },
            save(){
                var params={
                "loginName": this.form.loginName,
                "passwd": CryptoJS.MD5(this.form.passwd).toString(),
                "captcha":this.form.code,
                "key":this.form.key,
                "phoneCode": this.form.phoneCode,
                "userName": ""
                }
                Register(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "注册成功",
                            type: "success",
                        });
                        this.changeOperation('login');
                    }else{
                        this.queryCodeImg();
                    }
                }).catch(err=>{
                    this.queryCodeImg();
                })
            }
        },
        mounted(){
          this.queryCodeImg();
        }
    }
</script>

<style lang="less" scoped>
.register-box{
    width: 100%;
    background-image: url('../../assets/image/login/register.png');
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
}
.count-down{
    width: 100px;
    height: 32px;
    position: absolute;
    background-color: rgb(232,240,254);
    right: 14px;
    top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    font-size: 12px;
}
.content-box{
    display: flex;
    align-items: center;
}
.left-box{
    width: 340px;
    height: 530px;
    background: rgba(0, 17, 165,1);
    border-radius: 16px 0px 0px 16px;
    padding: 36px;
    .top-box{
        display: flex;
        cursor: pointer;
        i{
            font-size: 16px;
            margin-right: 5px;
        }
    }
    .name{
        font-size: 30px;
        text-align: center;
        margin-top: 85px;
    }
    .name-1{
        font-size: 26px;
        font-weight: 700;
        margin-top: 35px;
    }
    .describe{
        font-size: 14px;
        text-align: center;
        margin-top: 12px;
    }
}
.right-box{
    width: 460px;
    height: 500px;
    background: #ffffff;
    border-radius: 0px 16px 16px 0px;
    padding: 60px;
    position: relative;
    .close-flag{
        position: absolute;
        top: 20px;
        right: 20px;
        color: #000000;
        font-size: 18px;
        cursor: pointer;
    }
}
.back-box{
    color: #000000;
    display: flex;
    cursor: pointer;
    i{
            font-size: 16px;
            margin-right: 5px;
        }
}
.zd-register{
    color: #387DFF;
    font-weight: 700;
    font-size: 20px;
}
.first-box{
    display: flex;
    align-items: center;
    margin-top: 23px;
}
.btn-box{
    width: 100%;
    height: 40px;
    background: linear-gradient(-90deg,#72bbff 0%, #387dff 100%);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    margin-top: 60px;
    cursor: pointer;
}
.input-box{
    height: 44px;
    background-color: #FAFBFF;
    border-radius: 6px;
    margin-top: 14px;
    padding: 15px;
    display: flex;
    align-items: center;
    position: relative;
    .img{
        width: 110px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
    }
}
/deep/.el-input__inner{
    border: none;
    background-color: #FAFBFF;
}
/deep/.el-button--primary{
    background-color: #ffffff;
}
@media screen and (max-width:750px){
    .left-box{
        display: none;
    }
    .right-box{
        width: 100%;
    }
}
</style>